import Modal from "../Modal/Modal";
import Textfield from "../Input/Textfield";
import Button from "../Button/Button";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useDownloadHubPost from "@/shared/mutations/downloads/useDownloadHubPost";
import useDownloadHubPut from "@/shared/mutations/downloads/useDownloadHubPut";

const AddUrlModal = (props) => {
  const { t } = useTranslation();
  const setModal = useSetModal();
  const [{ id, name, url }] = useModalMeta();
  const { register, handleSubmit, errors } = useForm();
  const mutation = useDownloadHubPost();
  const update = useDownloadHubPut();

  const onSubmit = (data) => {
    if (id) {
      update.mutateAsync(
        { item_id: id, ...data },
        { onSuccess: () => setModal("", {}) }
      );
    } else {
      mutation.mutateAsync(data, { onSuccess: () => setModal("", {}) });
    }
  };

  return (
    <Modal onExit={() => setModal("")} {...props}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <Textfield
          name="name"
          defaultValue={name}
          label={t("name")}
          type="text"
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          error={errors?.name?.message}
        />
        <Textfield
          name="url"
          defaultValue={url}
          label={t("url")}
          type="text"
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          error={errors?.url?.message}
        />
        <Button
          type="submit"
          isPending={mutation.isPending || update.isPending}
        >
          {t("save")}
        </Button>
      </form>
    </Modal>
  );
};

export default AddUrlModal;
